import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FormattedMessage } from "react-intl";

import "./UnitConverter.scss";
import { formatWeight, getDecimalCount } from "helpers/commonHelpers";
import { ReactComponent as ExchangeIcon } from "assets/images/icons/Exchange.svg";
import ConverterInput from "./components/ConverterInput";
import { ConversionUnits } from "./components/options";

type UnitConverterProps = {
  content: React.ReactNode;
  value: number;
  unit: ConversionUnits;
  className?: string;
  iconStyle?: React.CSSProperties;
  showAlways?: boolean;
};

function UnitConverter(props: UnitConverterProps) {
  const { content, value, unit, className = "", iconStyle = {}, showAlways = true } = props;

  return (
    <div className={`unit-converter-wrapper ${className} ${!showAlways ? "default-hide" : ""}`}>
      {content}
      <OverlayTrigger
        trigger="click"
        placement="top"
        rootClose
        overlay={
          <Popover id="popover-basic" className="unit-converter-popover-container mb-3">
            <Popover.Content>
              <div className="font-weight-bold mt-2 d-flex justify-content-center">
                <FormattedMessage id="components.molecules.navigation.convert" defaultMessage="Convert" />
              </div>
              <div className="unit-converter-body-wrapper">
                <div>
                  <p>{formatWeight(getDecimalCount(value) > 5 ? value?.toFixed?.(5) : value, unit)}</p>
                </div>

                <div className="exchange-icon-container">=</div>

                <div>
                  <ConverterInput unit={unit} value={value} />
                </div>
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <div className="icon-container" style={iconStyle}>
          <ExchangeIcon />
        </div>
      </OverlayTrigger>
    </div>
  );
}

export default UnitConverter;

UnitConverter.defaultProps = {
  className: "",
  iconStyle: {},
  showAlways: false,
};
